export const privacyAndCookiePolicy = '/about/privacy-and-cookie-policy/';
export const googlePartners = '/about/google-partners/';
